import { useEffect, useState } from 'react';

export type CrashingOutSource = 'temporal' | 'postgres';

const STORAGE_KEY = 'crashing-out-source';

const normalizeSource = (value: string | null | undefined): CrashingOutSource => {
  return value === 'temporal' ? 'temporal' : 'postgres';
};

const getStoredSource = (): CrashingOutSource => {
  if (typeof window === 'undefined') {
    return 'postgres';
  }
  return normalizeSource(window.localStorage.getItem(STORAGE_KEY));
};

export const useCrashingOutSource = (): {
  source: CrashingOutSource;
  setSource: (nextSource: CrashingOutSource) => void;
} => {
  const [source, setSourceState] = useState<CrashingOutSource>(() => getStoredSource());

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key !== STORAGE_KEY) {
        return;
      }
      setSourceState(normalizeSource(event.newValue));
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const setSource = (nextSource: CrashingOutSource) => {
    setSourceState(nextSource);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, nextSource);
    }
  };

  return { source, setSource };
};
